<div id="contactInfo" class="container mx-auto" data-cy="contact-info">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evSimulator.steps.contactInfo.fields.contactInfo.title' | translate"
      [subtitle]="'modules.evSimulator.steps.contactInfo.fields.contactInfo.subtitle' | translate"
      data-cy="title"
    ></ife-title>

    <div class="form-group md:max-w-2xl md:mx-auto">
      <div
        class="form-element input-text"
        [class.errors]="!control.get('email').pristine && control.get('email').touched && control.get('email').invalid"
      >
        <div class="flex">
          <label>
            {{ 'modules.evSimulator.steps.contactInfo.fields.contactInfo.options.email' | translate }}
          </label>
          <app-tooltip
            data-cy="tooltip"
            [content]="'modules.evSimulator.steps.contactInfo.fields.contactInfo.options.consent' | translate"
            [position]="'left'"
          >
          </app-tooltip>
        </div>
        <input id="email" type="email" formControlName="email" data-cy="input-email" />
        <div class="message">
          <span *ngIf="!control.get('email').pristine && control.get('email').touched && control.get('email').invalid">
            {{ 'modules.evSimulator.steps.contactInfo.fields.contactInfo.errorMessage.email' | translate }}
          </span>
        </div>
      </div>

      <div
        class="form-element input-text mt-4"
        [class.errors]="!control.get('phone').pristine && control.get('phone').touched && control.get('phone').invalid"
      >
        <div class="flex">
          <label>
            {{ 'modules.evSimulator.steps.contactInfo.fields.contactInfo.options.phone' | translate }}
          </label>
        </div>
        <input id="phone" type="tel" formControlName="phone" data-cy="input-phone" />
        <div class="message">
          <span *ngIf="!control.get('phone').pristine && control.get('phone').touched && control.get('phone').invalid">
            {{ 'modules.evSimulator.steps.contactInfo.fields.contactInfo.errorMessage.phone' | translate }}
          </span>
        </div>
      </div>

      <div class="form-element input-checkbox mt-4">
        <div *ngIf="isPartnerSelectionCar; else newsletterField">
          <input id="gdpr" type="checkbox" formControlName="gdpr" data-cy="checkbox-gdpr" />
          <label
            for="gdpr"
            [innerHTML]="'modules.evSimulator.steps.contactInfo.fields.contactInfo.options.gdpr' | translate"
          >
          </label>
        </div>

        <ng-template #newsletterField>
          <input id="newsletter" type="checkbox" formControlName="newsletter" data-cy="checkbox-newsletter" />
          <label
            for="newsletter"
            [innerHTML]="'modules.evSimulator.steps.contactInfo.fields.contactInfo.options.newsletter' | translate"
          >
          </label>
        </ng-template>
      </div>
    </div>

    <ife-navigation
      [showNext]="true"
      [disabledNext]="!control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
